import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductDetailsComponent } from '../product-details/product-details.component';
import { HomeComponent } from '../home/home.component';
import { MatDialog } from '@angular/material/dialog';
import { MarketplaceManagerService } from 'src/app/services/marketplace-manager.service';
import { SubscriptionAppService } from 'src/app/services/subscription-app.service';

@Component({
  selector: 'app-avl-solutions',
  template: `
    <div class="toolbar">
      <div class="searchbox">
        <svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="m20 20-3-3" />
        </svg>
        <input
          type="text"
          placeholder="Search solutions"
          [(ngModel)]="searchTerm"
        />
      </div>
      <div class="count">{{ filteredVersions.length }} solutions</div>
    </div>

    <div class="mkt-grid">
      <div
        class="mkt-card"
        *ngFor="let version of filteredVersions"
        (click)="
          openPopup(
            keyValueExists(
              'solution_id',
              version['solution_id'],
              solutionsAvailableInMarketPlace
            ),
            version
          )
        "
      >
        <div class="mkt-top">
          <div class="mkt-ico">
            <svg
              viewBox="0 0 24 24"
              width="22"
              height="22"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="4" width="18" height="13" rx="2" />
              <path d="M8 21h8M12 17v4" />
            </svg>
          </div>
          <div style="flex:1;min-width:0">
            <div class="mkt-nm">
              {{
                keyValueExists(
                  'solution_id',
                  version['solution_id'],
                  solutionsAvailableInMarketPlace
                )['solution_name']
                  | textpretty
                  | titlecase
              }}
            </div>
          </div>
          <span
            class="badge b-sub"
            *ngIf="isSubscribed(version['solution_id'])"
          >
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
            Subscribed
          </span>
          <span
            class="badge b-new"
            *ngIf="!isSubscribed(version['solution_id'])"
            >New</span
          >
        </div>

        <div class="mkt-desc">
          {{
            mktDesc(
              keyValueExists(
                'solution_id',
                version['solution_id'],
                solutionsAvailableInMarketPlace
              )
            )
          }}
        </div>

        <div class="mkt-foot">
          <span class="vtag">Version {{ version['version_name'] }}</span>
          <button
            *ngIf="isSubscribed(version['solution_id'])"
            class="btn-ghost"
            type="button"
            (click)="
              $event.stopPropagation();
              openPopup(
                keyValueExists(
                  'solution_id',
                  version['solution_id'],
                  solutionsAvailableInMarketPlace
                ),
                version
              )
            "
          >
            Open
          </button>
          <button
            *ngIf="!isSubscribed(version['solution_id'])"
            class="btn-primary"
            type="button"
            (click)="
              $event.stopPropagation();
              openPopup(
                keyValueExists(
                  'solution_id',
                  version['solution_id'],
                  solutionsAvailableInMarketPlace
                ),
                version
              )
            "
          >
            View &amp; subscribe
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./avl-solutions.component.scss'],
})
export class AvlSolutionsComponent implements OnInit {
  solutionsAvailableInMarketPlace: any;
  versionAvailableInMarketPlace: any;
  componentCheck: boolean = false;
  columns: number = 3;
  searchTerm: string = '';
  subscribedSolutionIds: Set<string> = new Set<string>();
  constructor(
    private route: ActivatedRoute,
    private pDetails: MatDialog,
    private markeplaceServices: MarketplaceManagerService,
    private subscriptionAppService: SubscriptionAppService
  ) {}
  ngOnInit(): void {
    this.markeplaceServices.getSolutionInMarket().subscribe({
      next: (response: any) => {
        this.solutionsAvailableInMarketPlace = response['msg'];
        this.getVersionFromMarketplace();
      },
    });
    this.getSubscribedSolutions();
    if (this.route.component === HomeComponent) {
      this.componentCheck = true;
      this.columns = 1;
    } else {
      this.componentCheck = false;
    }
  }

  getSubscribedSolutions() {
    this.subscriptionAppService.getSubscribedSolutions().subscribe({
      next: (response: any) => {
        const items = response && response['msg'] ? response['msg'] : [];
        const ids = new Set<string>();
        for (const item of items) {
          if (item && item['solution_id']) {
            ids.add(item['solution_id']);
          }
        }
        this.subscribedSolutionIds = ids;
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  isSubscribed(solutionId: string): boolean {
    return this.subscribedSolutionIds.has(solutionId);
  }

  get filteredVersions(): any[] {
    const versions = this.versionAvailableInMarketPlace || [];
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      return versions;
    }
    return versions.filter((version: any) => {
      const solution = this.keyValueExists(
        'solution_id',
        version['solution_id'],
        this.solutionsAvailableInMarketPlace
      );
      const name =
        solution && solution['solution_name'] ? solution['solution_name'] : '';
      return String(name).toLowerCase().includes(term);
    });
  }

  mktDesc(solution: any): string {
    const fallback =
      'View the details to see what this solution does and how to subscribe.';
    if (!solution) {
      return fallback;
    }
    let desc = solution['user_facing_solution_desc'];
    if (!desc) {
      return fallback;
    }
    if (typeof desc === 'string') {
      try {
        desc = JSON.parse(desc);
      } catch (e) {
        return desc || fallback;
      }
    }
    if (desc && typeof desc === 'object') {
      return desc['subtitle'] || desc['description'] || fallback;
    }
    return fallback;
  }

  getVersionFromMarketplace() {
    this.markeplaceServices.getVersionInMarket().subscribe({
      next: (response: any) => {
        this.versionAvailableInMarketPlace = this.getLatestVersion(
          response['msg']
        );
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }

  getLatestVersion(data: any[]) {
    // Create a map to group data by version_id
    const groupedData = new Map();

    for (const item of data) {
      const solutionId = item.solution_id;

      if (!groupedData.has(solutionId)) {
        groupedData.set(solutionId, [item]);
      } else {
        groupedData.get(solutionId).push(item);
      }
    }

    const latestVersions = [];

    for (const [, group] of groupedData) {
      group.sort((a: any, b: any) => {
        const versionA = parseInt(a.version_name.substr(1));
        const versionB = parseInt(b.version_name.substr(1));
        return versionB - versionA;
      });

      latestVersions.push(group[0]);
    }

    return latestVersions;
  }

  openPopup(solution: any, version: any) {
    const versionDialogRef = this.pDetails.open(ProductDetailsComponent, {
      data: { soln: solution, versn: version },
      disableClose: false,
    });
    versionDialogRef.afterClosed().subscribe((selection) => {});
  }

  keyValueExists(key: string, value: any, data: any): any | boolean {
    const result = data.find((item: any) => item[key] === value);
    return result || false;
  }
}
